import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../components/foundations/Label';
import css from './FormInnerSection.css';

const FormInnerSection = ({ titleKey, descriptionKey, children }) => (
    <div className={css.innerSection}>
        <div className={css.innerSectionHeader}>
            <Label text={titleKey} type="p" className={css.innerSectionTitle} />
            {descriptionKey && <Label text={descriptionKey} type="p" />}
        </div>
        <div className={css.innerSectionContent}>{children}</div>
    </div>
);

FormInnerSection.propTypes = {
    titleKey: PropTypes.string.isRequired,
    descriptionKey: PropTypes.string,
    children: PropTypes.node,
};

export default FormInnerSection;
